import React from 'react'
import Block from '../block'
import { RichText, HtmlCode } from '../richTextOptions'
import PropTypes from 'prop-types'
import { getIsPreviewStatus } from '../../state/app'
import { connect } from 'react-redux'

function mapStateToProps(state) {
  return {
    isPreview: getIsPreviewStatus(state),
  }
}
const DownloadAsset = data => {
  return (
    <>
      {data.titleDownloadAsset && (
        <RichText data={data.titleDownloadAsset}></RichText>
      )}
      {data.fileDownloadAsset && <Block block={data.fileDownloadAsset}></Block>}
    </>
  )
}

DownloadAsset.propTypes = {
  isPreview: PropTypes.bool,
}

const ContentfulBlockDownloadAsset = connect(mapStateToProps)(DownloadAsset)

export { ContentfulBlockDownloadAsset }
